// extracted by mini-css-extract-plugin
export default {"wrapper":"zoAbMMGUffUf0jP6aOos"};